<template>
    <MenuButton
        v-if="!isOpen"
        class="relative"
        variant="outline"
        :title="$t('change-locale')"
        placement="bottom"
        :aria-label="$t('change-locale')"
        :on-click="toggleOpen"
    >
        <span class="sr-only">{{ $t('change-locale') }}</span>
        <GlobeIcon class="w-3 h-3" />
        <span class="uppercase text-xs">{{ routeLang.code.value }}</span>
    </MenuButton>
    <div v-else class="fixed bg-primary-dark transition-colors left-0 w-full h-20 lg:h-25 flex flex-row items-center justify-between space-x-2 text-light z-10 px-4 lg:p-5">
        <div class="flex flex-row items-center justify-between space-x-2">
            <GlobeIcon class="w-6 h-6" />
            <div>{{ $t('change-locale') }}:</div>
            <Link
                v-for="item in enums.languages"
                :key="item.code"
                :class="[ 'uppercase no-underline hover:underline cursor-pointer' ]"
                :href="switchLocalePath(item.code)"
                active-class="font-bold"
                :title="item.name"
                @click.prevent="() => handleClick(item)"
            >
                {{ item.code }}
            </Link>
        </div>
        <button
            :aria-label="$t('text-close')"
            class="inline-block outline-none focus:outline-none w-4 h-4"
            @click.prevent="toggleOpen"
        >
            <span class="sr-only">{{ $t("text-close") }}</span>
            <CloseIcon class="w-4 h-4" />
        </button>
    </div>
</template>

<script setup>
import _ from 'lodash-es';
import { useEnumStore } from '@stores/enum';
import { useSelectedStore } from '@stores/selected';
import GlobeIcon from "@components/icons/outline/globe-icon";
import CloseIcon from '@components/icons/close-icon'
import MenuButton from "@components/ui/menu-button";
import Link from "@components/ui/link/link";

const enums = useEnumStore();
const store = useSelectedStore();
const switchLocalePath = useSwitchLocalePath();
const routeLang = useRouteLang();

const isOpen = ref(false);

const toggleOpen = () => {
    isOpen.value = !isOpen.value;
}

const handleClick = async (item) => {
    toggleOpen();
    await navigatorTo(switchLocalePath(item.code));
    await visitorUpdate(item.id);
    store.setLoadResetAll();
    _.delay(async () => {
        await loadPublicMasterData();

        // await loadCategories(true);
        // await loadEshopParameters(true);
        // await loadContentParameters(true);
        // await loadEshopAvailabilities(true);
        // await loadAbandonmentReasons(true);
        // await loadBanners(true);
    }, 500);
}

</script>
